import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { ReferenceBook } from '@/features/referenceBooks/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

/** Legal form picker for the connection-application form (ТОВ/АТ/ПрАТ/ФОП/ФО/...). Read-only proxy
 * onto the platform-wide reference book — see ConnectionApplicationEntity.OrganizationalLegalFormId. */
export const organizationalLegalFormsApi = createApi({
  reducerPath: 'organizationalLegalFormsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/organizational-legal-forms',
  }),
  endpoints: builder => ({
    getOrganizationalLegalForms: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '' }),
    }),
  }),
});

export const { useGetOrganizationalLegalFormsQuery } = organizationalLegalFormsApi;
